import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: '',
} as { token: string };

const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state) => ({ ...state }),
  },
});

export const { setToken } = auth.actions;
export default auth.reducer;
